import * as Yup from 'yup';
import { v4 as uuidV4 } from 'uuid';
import { ICarrier } from './carrier';
import { ICarrierFormValues } from './carrierFormValues';
import { ICarrierUpsert } from './carrierUpsert';

export default class CarrierModelHelper {
    public static createFormValues = (carrier : ICarrier | null) : ICarrierFormValues => {
        if (!carrier) return {
            id: 0,
            guid: uuidV4(),
            code: '',
            name: '',
            isActive: true,
        };

        return {
            id: carrier.id,
            guid: carrier.guid,
            code: carrier.code,
            name: carrier.name,
            isActive: carrier.isActive,
        };
    };

    public static createUpsert = (formValues : ICarrierFormValues) : ICarrierUpsert => {
        return {
            id: formValues.id,
            guid: formValues.guid,
            code: formValues.code,
            name: formValues.name,
            isActive: formValues.isActive,
        };
    };

    public static formSchema = () : Yup.ObjectSchema<ICarrierFormValues> => Yup.object().shape({
        id: Yup.number().typeError('Please enter a number.').required('Required'),
        guid: Yup.string().required('Required'),
        code: Yup.string().trim().min(1, 'Must have at least 1 character').required('Required'),
        name: Yup.string().trim().min(1, 'Must have at least 1 character').required('Required'),
        isActive: Yup.boolean().required('Required'),
    });
}
